export default __webpack_public_path__ + "static/media/misc-closet2-1024w.23dea6ad.webp";